import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/common/SimpleSnackbar.js";
import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

/**
 * This is a modified version of the demo for the material-ui Snackbar.
 *
 * https://material-ui.com/demos/snackbars/
 */
class SimpleSnackbar extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setMessage", message => {
      this.state.message = message;
    });
    _defineProperty(this, "handleOpen", () => {
      this.setState({
        open: true
      });
    });
    _defineProperty(this, "handleClose", (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      this.setState({
        open: false
      });
    });
    this.state = {
      open: false,
      message: '',
      autoHideSeconds: props.autoHideSeconds != null ? props.autoHideSeconds : 3
    };
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Snackbar, {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      open: this.state.open,
      autoHideDuration: this.state.autoHideSeconds * 1000,
      onClose: this.handleClose,
      ContentProps: {
        'aria-describedby': 'message-id'
      },
      message: /*#__PURE__*/React.createElement("span", {
        id: "message-id",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 30
        }
      }, this.state.message),
      action: /*#__PURE__*/React.createElement(IconButton, {
        key: "close",
        "aria-label": "Close",
        color: "inherit",
        onClick: this.handleClose,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 29
        }
      })),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 17
      }
    }));
  }
}
export default SimpleSnackbar;